import { IPurchaseForm } from './types';
import { FieldPath, UseFormReturn } from 'react-hook-form';

export const countFtvValue = (deposit: number, financingAmount: number | null): number | null =>
  financingAmount ? (financingAmount / (financingAmount + deposit)) * 100 : 0;

export const updateError = <T extends IPurchaseForm>(
  form: UseFormReturn<T>,
  field: FieldPath<T>,
  error?: string | true | null,
) => (typeof error === 'string' ? form.setError(field, { message: error }) : form.clearErrors(field));
